module.exports = __webpack_public_path__ + "img/personal18.dc7ca0a4.jpg";